import { render, staticRenderFns } from "./addChainProduct.vue?vue&type=template&id=5231f31f&scoped=true"
import script from "./addChainProduct.vue?vue&type=script&lang=js"
export * from "./addChainProduct.vue?vue&type=script&lang=js"
import style0 from "./addChainProduct.vue?vue&type=style&index=0&id=5231f31f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231f31f",
  null
  
)

export default component.exports